import { Component, Input } from '@angular/core';
import { IPatientInfo } from '../../ipatient-info';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { DefaultValuePipe } from 'src/app/pipe/default-value.pipe';
import { AgePipe } from 'src/app/pipe/age-calculate.pipe';

@Component({
  selector: 'app-personal-details',
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    DefaultValuePipe,
    AgePipe
  ],
  templateUrl: './personal-details.component.html',
  styleUrl: './personal-details.component.scss'
})
export class PersonalDetailsComponent {
  @Input() patientDetails: IPatientInfo | undefined;
}
